import { Module } from '@nestjs/common';
import { PrismaService } from '@cart/api-data-access';
import { BrandingModule } from '../branding/branding.module';
import { ReadinessController } from './readiness.controller';
import { ReadinessService } from './readiness.service';

@Module({
  // BrandingModule for the SEO completeness score, so the readiness checklist
  // and the SEO meter cannot disagree about how complete a listing is.
  imports: [BrandingModule],
  controllers: [ReadinessController],
  providers: [PrismaService, ReadinessService],
  exports: [ReadinessService],
})
export class ReadinessModule {}
